/*eslint no-undef: 0*/

export default {
  finalize() {
    let notification_page = 1,
      notification_card_wrapper = $('#notification-container'),
      notification_wrapper = $('.notifications-wrapper'),
      notification_pagination_wrapper = $('#pagination-wrapper'),
      notification_header_wrapper = $('#header-notification-wrapper'),
      header_notif_count = $('#header-notif-count');

    function get_notifications() {
      let loader = $('#notification-skeleton');

      $.ajax(
        {
          url: follow.ajax_url,
          type: 'GET',
          dataType: 'json',
          data: {
            security: follow.nonce,
            action: 'get_user_notifications',
            pagednum: notification_page,
          },
          beforeSend: function () {
            loader.removeClass('is-invisible d-none');
            notification_card_wrapper.addClass('d-none').empty();
          },
          success: function (response) {
            //
            notification_card_wrapper.removeClass('d-none');

            loader.addClass('d-none').promise().done(function () {
              if (response.html) {
                notification_card_wrapper.html(response.html);
                notification_pagination_wrapper.removeClass('d-none');
              } else {
                notification_card_wrapper.html('<div class="alert alert-danger">No notifications found</div>');
                notification_pagination_wrapper.addClass('d-none');
              }
              notification_pagination_wrapper.html(response.pagination);
            });
          },
        }
      );
    }

    let notifications_tab = $('#v-account-notifications-tab');
    notifications_tab.on('shown.bs.tab', function () {
      get_notifications();
    });

    let userNotifications = $('#userNotifications');
    userNotifications.on('click', function () {
      get_notifications();
    });

    notification_pagination_wrapper.on('click', '.page-link', function (e) {
      e.preventDefault();

      let el = $(this);
      if (!el.hasClass('active')) {
        notification_page = $(this).data('page');
        get_notifications();
      }

    });

    notification_card_wrapper.on('click', '.notification-card__close', function (e) {
    let el = $(this);
    e.preventDefault();
    $.ajax(
        {
            url: follow.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                security: follow.nonce,
                action: 'remove_user_notification',
                id: el.data('id'),
            },
            beforeSend: function () {
                el.toggleClass('disabled');
                el.parent().find('a').toggleClass('disabled');
                el.parents('.notification-card').toggleClass('disabled');
            },
            success: function () {
                el.parents('.notification-card').fadeOut().remove();
                notification_header_wrapper.find('.notification-'+el.data('id')).fadeOut().remove();
                if(el.parents('.notification-card').hasClass('is-unread')){
                  header_notif_count.text(parseInt(header_notif_count.text()) - 1);
                }
            },
        });
    });

    notification_wrapper.on('click', 'a.notification-link', function (e) {
      e.preventDefault();
      let el = $(this);
      $.ajax(
        {
            url: follow.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: {
                security: follow.nonce,
                action: 'mark_as_read',
                id: el.data('notif'),
                href: el.attr('href'),
            },
            success: function (response) {
              notification_header_wrapper.find('.notification-'+el.data('notif')).removeClass('is-unread');
              window.location = response.href;
            },
        });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-portal-account.js